import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string'
import IconButton from 'material-ui/IconButton';
import ActionAssignment from 'material-ui/svg-icons/action/assignment';

const NoteButton = ({ basePath = '', record = {} }) => {
	return (
	    <IconButton
			containerElement={<Link 
				to={{
					pathname: `${basePath}/${record.id}`, 
					search: stringify({ tab: 3 })
				}} />}
			style={{ display: 'flex', margin: '0 auto' }} >
			{ !! record.fields.collector_notes && <ActionAssignment color="#0277bd" /> }
			{ ! record.fields.collector_notes && <ActionAssignment color="#dddddd" /> }
	    </IconButton>
	);
}

NoteButton.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

NoteButton.defaultProps = {
    style: { padding: 0 },
};

export default NoteButton;



// WEBPACK FOOTER //
// ./src/CollectorAccount/NoteButton.js